export function updateFlavorSlider() {
  const swiperEl = document.querySelector('swiper-container.product-flavor-slider');
  if (swiperEl && swiperEl.swiper) {
    swiperEl.swiper.update();
    swiperEl.swiper.navigation.update();

    const slides = swiperEl.querySelectorAll('swiper-slide');
    let targetIndex = -1;
    slides.forEach((slide, idx) => {
      if (slide.querySelector('a[aria-current="page"]')) {
        targetIndex = idx;
      }
    });

    if (targetIndex > 3) {
      swiperEl.swiper.slideTo(targetIndex, 0);
    }
  }
}